<template>
	<v-flex xs4 offset-xs4 v-if="!currentLogin">
		<v-form v-model="valid" @submit="auth">
			<v-card class="auth-panel">
				<v-card-title>Авторизация</v-card-title>
				<v-card-text>
					<v-text-field
						required
						v-model="login"
						label="Логин"
						name="login"
						prepend-icon="mdi-account"
						:rules="[required]"
					></v-text-field>
					<v-text-field
						required
						v-model="password"
						id="password"
						label="Пароль"
						name="password"
						prepend-icon="mdi-lock"
						:rules="[required]"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showPassword ? 'text' : 'password'"
						@click:append="showPassword = !showPassword"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<div class="flex-grow-1"></div>
					<v-btn
						text
						@click="auth"
						:disabled="!valid"
						type="submit"
					>Войти
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-flex>
</template>

<script>
  export default {
    name: "AuthPage",
    props: {
      inputRoute: String,
      authorize: Function,
      currentLogin: String,
    },
    data: () => {
      return {
        valid: false,
        showPassword: false,
        login: '',
        password: '',
      }
    },
    methods: {
      // валидация полей
      required: value => !!value || "Это поле не может быть пустым.",

      auth: function (e) {
        e.preventDefault();
        this.authorize(this.login, this.password);
      },
    },
  }
</script>

<style scoped>
	.auth-panel {
		margin-top: 30vh;
	}
</style>